module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumbs-layout', {
    attrs: {
      "breadcrumbs": _vm.crumbs
    }
  }, [_c('article-page', {
    attrs: {
      "name": _vm.pageTitle,
      "article": _vm.pageText
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b17c3ce","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pf-dod/Info.vue
// module id = 051b23479c5fe150f23d
// module chunks = 79